import log from "../utils/log";

export class BikehubQrCode {
  init() {
    this.expirationReloadSeconds = parseInt(
      $("#qrCodeImage").attr("data-expirationreload"),
      10
    );
    this.renderQrCode();

    const $container = $("#qrCodeImage").parents(".container-fluid");
    // remove wrapping padding, the QR has enough wrapping padding
    $container.css("padding", "0");
    $container.removeClass("mt-4"); // GAH, freaking importants
  }

  renderQrCode() {
    const imagePath = $("#qrCodeImage").attr("data-imagepath");
    $("#qrCodeImage").html(`<img src="${imagePath}" class="code-image">`);
    // Make sure it isn't bigger than the screen (minus the navbar)
    $("#qrCodeImage .code-image").css(
      "max-height",
      `${window.innerHeight - 60}px`
    );
    // Render a new QR code when this one expires
    return setTimeout(this.renderQrCode, this.expirationReloadSeconds * 1000);
  }
}
